/* eslint-disable */
import axios from 'axios'
import mapBoxGl from 'mapbox-gl'
import { MapboxLayer } from '@deck.gl/mapbox'
import { TripsLayer } from '@deck.gl/geo-layers'
import 'mapbox-gl/dist/mapbox-gl.css'
import { Threebox, THREE } from 'threebox-plugin'
import AnimatedPopup from 'mapbox-gl-animated-popup'
import * as turf from '@turf/turf'
import Wkt from 'wicket'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import {
  wall,
  models,
  breathe,
  rotate,
  hangLine,
  // flowLine,
  gradualChangeLine,
  gradualChangeColumn,
  // spread
} from './mapServe.umd.min.js'
import Bus from '@/config/Bus'
import { useMainStore } from '@/store/main'
import pinia from '@/store/index'
import { def } from '@vue/shared'

export function request(config) {
  // 创建axios实例
  const instance = axios.create({
    baseURL: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap',
  })
  return instance(config)
}
export function request2(config) {
  // 创建axios实例
  const instance = axios.create({
    // baseURL: 'http://119.84.149.201:18093/map/nymy-map',
    baseURL: 'https://xcx.ljh.cqhtwl.com.cn/files/map/nymy-map',
  })
  return instance(config)
}
const mainStore = useMainStore(pinia)
new breathe.data({ addCustomLayer: addCustomLayer, removeCustomLayer: removeCustomLayer })
new rotate.data({ addCustomLayer: addCustomLayer, removeCustomLayer: removeCustomLayer })
new hangLine.data({ addCustomLayer: addCustomLayer, removeCustomLayer: removeCustomLayer })
// new flowLine.data(({ addCustomLayer: addCustomLayer, removeCustomLayer: removeCustomLayer }))
new gradualChangeLine.data({ addCustomLayer: addCustomLayer, removeCustomLayer: removeCustomLayer })
new gradualChangeColumn.data({
  addCustomLayer: addCustomLayer,
  removeCustomLayer: removeCustomLayer,
})
new models.data({ addCustomLayer: addCustomLayer, removeCustomLayer: removeCustomLayer })
new wall.data({ addCustomLayer: addCustomLayer, removeCustomLayer: removeCustomLayer })
// new spread.data(({ addCustomLayer: addCustomLayer, removeCustomLayer: removeCustomLayer }))

let that
let customLayer = [] //自定义图层组
let map = undefined
let initialObject = {
  //地图初始参数
  center: [105.918014, 29.168635],
  zoom: 10.5,
  pitch: 50,
  bearing: 0,
  speed: 0.2,
}
let lastIds = []
let newFlowLine
let clickStart = false //是否能点击
let spreadSetInterval = undefined //扩散效果的定时器对象
let spreadSetTimeout = undefined //扩散效果开始的定时器对象
let boxSetInterval = undefined //方块下拉动画定时器
let zbmdSetInterval = undefined //周边蒙版动画定时器
let activeName = undefined //当前选择的区县名称
let hoveredStateId = null //覆盖高亮对象id
let hdhjHoveredStateId = null //河道标记覆盖对象id
let clickedStateId = null //点击高亮对象id
let xzData //乡镇数据
let hllxData //河流中心线
let hlmData //河流面
let lyData //流域面
let subBasinData //子流域
let mousemoveFeature //鼠标覆盖时获取的feature
let zjClickFun //点击镇街的回调函数
let zoomFun //层级变化回调
let zoomendFun = []
let routeTrackingData //路径追踪数据
let routeTrackingIndex //路径追踪位置
let routeTrackingState //路径追踪状态
let ProblemMark = [] //问题点集合
let LyMark = [] //流域点集合
let HighlightRivers //高亮的河流
let HighlightRiversBefore //河流高亮前的颜色
let HighlighttRibutaryBefore //河流支流高亮前的颜色
let selectLY //选中流域
let DiversionWaterData = [] //引调提水数据
let mapState = false
// 定义EPSG:32648投影参数 (UTM Zone 48N)
proj4.defs("EPSG:32648", "+proj=utm +zone=48 +datum=WGS84 +units=m +no_defs");
// 定义EPSG:4326 (WGS84)
proj4.defs("EPSG:4326", "+proj=longlat +datum=WGS84 +no_defs");

request({
  url: '/yczhhz/json/乡镇.json',
}).then((res) => {
  xzData = res.data
})
request({
  url: '/yczhhz/json/河流中心线.json',
}).then((res) => {
  hllxData = res.data
})
request({
  url: '/yczhhz/json/河流面.json',
}).then((res) => {
  hlmData = res.data
})
request({
  url: '/yczhhz/json/流域.json',
}).then((res) => {
  lyData = res.data
})
request2({
  url: '/sub_FeaturesToJSON.json'
}).then((res) => {
  subBasinData = res.data
  console.log('sub----->', subBasinData);
})
let animation = {
  id: 0,
}
function addCustomLayer(data) {
  customLayer.push(data)
}
function removeCustomLayer(id) {
  for (let i = customLayer.length - 1; i >= 0; i--) {
    if (customLayer[i].id === id) {
      customLayer.splice(i, 1)
    }
  }
}

class mapService {
  constructor(accessToken) { }
  async initMap(object, token, vue) {
    that = vue
    mapBoxGl.accessToken = token
    map = new mapBoxGl.Map(object)

    window.map = map
    window.tb = new Threebox(map, map.getCanvas().getContext('webgl'), {
      defaultLights: true,
    })

    let position = {
      1: [64, 97],
      2: [57, 93],
      3: [50, 90],
      4: [72, 42],
      5: [0, 0],
      6: [68, 44],
      7: [14, 16],
      8: [34, 5],
    }
    let type = [
      {
        name: '河道监控',
      },
      {
        name: '污染源监控',
      },
      {
        name: '水库监控',
      },
      {
        name: '饮用水源地监控',
      },
      {
        name: '管网监控',
      },
    ]
    let state = [
      {
        name: 'zx',
        color: '#98DAFF',
      },
      {
        name: 'lx',
        color: '#D9D9D9',
      },
      {
        name: 'bj',
        color: '#FF9797',
      },
    ]
    for (let t = 0; t < type.length; t++) {
      for (let s = 0; s < state.length; s++) {
        const canvas = document.createElement('canvas')
        canvas.width = 146
        canvas.height = 112
        // if (type[t].name == '饮用水源地监控') {
        //     canvas.width = 156;
        // }
        let context = canvas.getContext('2d')
        for (let i = 1; i <= 8; i++) {
          const img = document.createElement('img')
          img.src = require('@/assets/img/map/jk/' + state[s].name + '_' + i + '.png')
          const _this = this
          img.onload = function () {
            //onload必须使用
            // if (type[t].name == '饮用水源地监控') {
            //     if (i == 5) {
            //         context.drawImage(this, ...position[i], 156, 38);
            //     }
            //     else if (i == 1 || i == 2 || i == 3 || i == 4 || i == 6) {
            //         context.drawImage(this, position[i][0] + 15, position[i][1]);
            //     }
            //     else {
            //         context.drawImage(this, ...position[i]);
            //     }
            // }
            // else {
            //     context.drawImage(this, ...position[i]);
            // }
            context.drawImage(this, ...position[i])
            if (i == 8) {
              // context.font = "normal 14px 'Microsoft YaHei'";
              // context.fillStyle = state[s].color;
              // context.fillText(type[t].name, 45, 25);
              let imageName = type[t].name
              switch (s) {
                case 1:
                  imageName = imageName + '_0'
                  break
                case 2:
                  imageName = imageName + '_1'
                  break
                default:
              }
              map.loadImage(canvas.toDataURL('image/png'), (error, image) => {
                if (error) throw error
                map.addImage(imageName, image)
              })
            }
          }
        }
      }
    }
    map.loadImage(
      'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/mapbox/图标/b2-right.png',
      (error, image) => {
        if (error) throw error
        map.addImage('b2-right.png', image)
      }
    )
    map.loadImage(require('@/assets/img/map/riverDetails.png'), (error, image) => {
      if (error) throw error
      map.addImage('riverDetails.png', image)
    })
    map.loadImage(require('@/assets/img/map/视频监控.png'), (error, image) => {
      if (error) throw error
      map.addImage('河道视频', image)
    })
    map.loadImage(require('@/assets/img/map/视频监控_0.png'), (error, image) => {
      if (error) throw error
      map.addImage('河道视频_0', image)
    })
    map.loadImage(require('@/assets/img/map/视频监控_1.png'), (error, image) => {
      if (error) throw error
      map.addImage('河道视频_1', image)
    })
    map.loadImage(require('@/assets/img/map/UAV.png'), (error, image) => {
      if (error) throw error
      map.addImage('UAV', image)
    })
    map.loadImage(require('@/assets/img/map/畜禽养殖场.png'), (error, image) => {
      if (error) throw error
      map.addImage('畜禽养殖.png', image)
    })
    map.loadImage(require('@/assets/img/map/畜禽养殖场.png'), (error, image) => {
      if (error) throw error
      map.addImage('畜禽养殖_0.png', image)
    })
    map.loadImage(require('@/assets/img/map/畜禽养殖场.png'), (error, image) => {
      if (error) throw error
      map.addImage('畜禽养殖_1.png', image)
    })
    map.loadImage(require('@/assets/img/map/水产养殖场.png'), (error, image) => {
      if (error) throw error
      map.addImage('水产养殖.png', image)
    })
    map.loadImage(require('@/assets/img/map/水产养殖场.png'), (error, image) => {
      if (error) throw error
      map.addImage('水产养殖_0.png', image)
    })
    map.loadImage(require('@/assets/img/map/水产养殖场.png'), (error, image) => {
      if (error) throw error
      map.addImage('水产养殖_1.png', image)
    })
    map.loadImage(require('@/assets/img/map/水位站.png'), (error, image) => {
      if (error) throw error
      map.addImage('水位站.png', image)
    })
    map.loadImage(require('@/assets/img/map/水位站_0.png'), (error, image) => {
      if (error) throw error
      map.addImage('水位站_0.png', image)
    })
    map.loadImage(require('@/assets/img/map/水文站.png'), (error, image) => {
      if (error) throw error
      map.addImage('水文站.png', image)
    })
    map.loadImage(require('@/assets/img/map/水文站_0.png'), (error, image) => {
      if (error) throw error
      map.addImage('水文站_0.png', image)
    })
    map.loadImage(require('@/assets/img/map/雨量站_0.png'), (error, image) => {
      if (error) throw error
      map.addImage('雨量站_0.png', image)
    })
    map.loadImage(require('@/assets/img/map/雨量站.png'), (error, image) => {
      if (error) throw error
      map.addImage('雨量站.png', image)
    })
    map.loadImage(require('@/assets/img/map/雨量站.png'), (error, image) => {
      if (error) throw error
      map.addImage('雨量站.png', image)
    })

    map.loadImage(require('@/assets/img/map/起点.png'), (error, image) => {
      if (error) throw error
      map.addImage('起点.png', image)
    })
    map.loadImage(require('@/assets/img/map/终点.png'), (error, image) => {
      if (error) throw error
      map.addImage('终点.png', image)
    })
    map.loadImage(require('@/assets/img/map/重点监管.png'), (error, image) => {
      if (error) throw error
      map.addImage('重点监管.png', image)
    })
    map.loadImage(require('@/assets/img/map/污水排口.png'), (error, image) => {
      if (error) throw error
      map.addImage('重点排水户_0.png', image)
    })

    var size = 80

    var pulsingDot = {
      width: size,
      height: size,
      data: new Uint8Array(size * size * 4),

      onAdd: function () {
        var canvas = document.createElement('canvas')
        canvas.width = this.width
        canvas.height = this.height
        this.context = canvas.getContext('2d')
      },

      render: function () {
        var duration = 1000
        var t = (performance.now() % duration) / duration

        var radius = (size / 2) * 0.4
        var outerRadius = (size / 2) * 0.6 * t + radius
        var context = this.context

        // draw outer circle
        context.clearRect(0, 0, this.width, this.height)
        context.beginPath()
        context.arc(this.width / 2, this.height / 2, outerRadius, 0, Math.PI * 2)
        context.fillStyle = 'rgba(58, 255, 237,' + (1 - t) + ')'
        context.fill()

        // draw inner circle
        context.beginPath()
        context.arc(this.width / 2, this.height / 2, radius, 0, Math.PI * 2)
        context.fillStyle = 'rgba(0, 255, 231, 1)'
        // context.strokeStyle = 'white';
        // context.lineWidth = 2 + 4 * (1 - t);
        context.fill()
        // context.stroke();

        // update this image's data with data from the canvas
        this.data = context.getImageData(0, 0, this.width, this.height).data

        // keep the map repainting
        map.triggerRepaint()

        // return `true` to let the map know that the image was updated
        return true
      },
    }
    map.addImage('pulsing-dot', pulsingDot, { pixelRatio: 2 })
    map.on('zoomend', () => {
      let zoom = map.getZoom()
      for (let i = 0; i < zoomendFun.length; i++) {
        zoomendFun[i](zoom)
      }
    })
    map.on('zoom', () => {
      let zoom = map.getZoom()
      zoomFun && zoomFun(zoom)
      //扩散效果
      // if (zoom > 11) {
      //     this.stopSpread()
      // }
      // else {
      //     this.spread()
      // }
      //高程
      if (zoom > 11) {
        // map.setTerrain({ source: "hlccbnum6", exaggeration: 1 });
        if (mainStore.terrain) {
          map.setTerrain({ source: 'hlccbnum6', exaggeration: 1 })
        } else {
          map.setTerrain(undefined)
        }
        map.setFeatureState(
          { source: 'yc', id: hoveredStateId, sourceLayer: '乡镇' },
          { hover: false }
        )
      } else {
        map.setTerrain(undefined)
      }
      if (HighlightRivers || zoom > 11) {
        map.setLayoutProperty('zj-河流注记', 'visibility', 'visible')
      } else {
        map.setLayoutProperty('zj-河流注记', 'visibility', 'none')
      }
      // else {
      //     map.setTerrain(null);
      // }
      //天空
      // if (zoom >= 14) {
      //     map.setLayoutProperty('sky', 'visibility', 'visible');
      // }
      // else {
      //     map.setLayoutProperty('sky', 'visibility', 'none');
      // }
    })
    // map.on("load",()=>{
    //     map.getSource('video').play()
    //     map.setLayoutProperty("video","visibility","visible")
    // })
    map.once('load', () => {
      mapState = true
      // this.loadVideo(map, this)
      this.addPipeAnimateLayer()
      // setTimeout(() => {
      //   this.addmodels()
      // }, 1000)

      // let gradualChangeColumnLayer = gradualChangeColumn.gradualChangeColumnLayer
      // let xxxx = new gradualChangeColumnLayer('xxxx', [
      //   [105.84089203715024, 29.426463462824259, 3000],
      //   [105.723288631839324, 29.236290164894204, 3000],
      //   [106.027792958652867, 29.428362697954913, 3000],
      //   [105.87806198127879, 29.251619478071376, 3000],
      //   [105.796322634034482, 29.048918329955136, 3000],
      //   [105.893341616165074, 29.072759643212674, 3000],
      // ],
      // 4000)
      // xxxx.show()
    })
    map.once('styledata', () => {
      // 添加流域点位
      this.addLyMark()
      setTimeout(() => {
        HighlighttRibutaryBefore = map.getPaintProperty('sx-支流线', 'line-color')
        HighlightRiversBefore = map.getPaintProperty('xzgl-河流水质', 'fill-color')
      }, 1000)
    })
    map.on('click', (e) => {
      this._clickMap(e, this) //同时传递this
    })
    map.on('mousemove', function (e) {
      // let features = map.queryRenderedFeatures(e.point);
      // // console.log(features)
      // if(features[0].properties.name&&(!mousemoveFeature||mousemoveFeature.layer.id!=features[0].layer.id||features[0].properties.name != mousemoveFeature.properties.name)) {
      //     mousemoveFeature = features[0]
      //     features[0] && Bus.$emit('mapMousemove', features[0].properties)
      // }
    })
    map.on('mousemove', 'hdhj-界桩标记', function (e) {
      if (e.features.length > 0) {
        if (hdhjHoveredStateId) {
          map.setFeatureState(
            { source: 'hdhj', id: hdhjHoveredStateId, sourceLayer: '界桩' },
            { hover: false }
          )
        }
        hdhjHoveredStateId = e.features[0].id
        map.setFeatureState(
          { source: 'hdhj', id: hdhjHoveredStateId, sourceLayer: '界桩' },
          { hover: true }
        )
      } else {
        map.setFeatureState(
          { source: 'hdhj', id: hdhjHoveredStateId, sourceLayer: '界桩' },
          { hover: false }
        )
      }
    })
    map.on('mouseleave', 'hdhj-界桩标记', function () {
      if (hdhjHoveredStateId) {
        // map.setPaintProperty("xzgl-乡镇注记-未选中", "text-opacity", 0);
        map.setFeatureState(
          { source: 'hdhj', id: hdhjHoveredStateId, sourceLayer: '界桩' },
          { hover: false }
        )
      }
      hdhjHoveredStateId = null
    })
    map.on('mousemove', 'yd-乡镇-click', function (e) {
      // map.setPaintProperty('xzgl-乡镇注记-未选中', 'text-opacity', [
      //   'case',
      //   ['boolean', ['feature-state', 'hover'], false],
      //   0,
      //   1,
      // ])
      if (e.features.length > 0 && map.getZoom() <= 14) {
        if (hoveredStateId) {
          map.setFeatureState(
            { source: 'yc', id: hoveredStateId, sourceLayer: '乡镇' },
            { hover: false }
          )
          map.setFeatureState(
            { source: 'yc', id: hoveredStateId, sourceLayer: '乡镇标记点' },
            { hover: false }
          )
        }
        if (e.features[0].properties.NAME != activeName) {
          hoveredStateId = e.features[0].id
          map.setFeatureState(
            { source: 'yc', id: hoveredStateId, sourceLayer: '乡镇' },
            { hover: true }
          )
          map.setFeatureState(
            { source: 'yc', id: hoveredStateId, sourceLayer: '乡镇标记点' },
            { hover: true }
          )
        }
      } else {
        map.setFeatureState(
          { source: 'yc', id: hoveredStateId, sourceLayer: '乡镇' },
          { hover: false }
        )
        map.setFeatureState(
          { source: 'yc', id: hoveredStateId, sourceLayer: '乡镇标记点' },
          { hover: false }
        )
      }
    })

    // When the mouse leaves the state-fill layer, update the feature state of the
    // previously hovered feature.
    map.on('mouseleave', 'yd-乡镇-click', function () {
      if (hoveredStateId) {
        // map.setPaintProperty("xzgl-乡镇注记-未选中", "text-opacity", 0);
        map.setFeatureState(
          { source: 'yc', id: hoveredStateId, sourceLayer: '乡镇' },
          { hover: false }
        )
        map.setFeatureState(
          { source: 'yc', id: hoveredStateId, sourceLayer: '乡镇标记点' },
          { hover: false }
        )
      }
      hoveredStateId = null
    })
    return map
  }

  //获取地图加载状态
  getMapState() {
    return mapState
  }

  //添加模型
  addmodels() {
    var model = [
      'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/model/ycqdh00-1.glb',
      'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/model/ycqdh00-3.glb',
      'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/model/ycqdh2-4.glb',
      'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/model/ycqdh2-2.glb',
    ]
    for (let i = 0; i < model.length; i++) {
      map.getLayer('3d-model' + i) && map.removeLayer('3d-model' + i)
    }
    const that = this
    const mouse = new THREE.Vector4(-1000, -1000, 1, 1)
    // parameters to ensure the model is georeferenced correctly on the map
    var modelOrigin = [105.868014, 29.278635]
    var modelAltitude = 0
    var modelRotate = [Math.PI / 2, 0, 0]
    var modelAsMercatorCoordinate = mapBoxGl.MercatorCoordinate.fromLngLat(
      modelOrigin,
      modelAltitude
    )
    // transformation parameters to position, rotate and scale the 3D model onto the map
    var modelTransform = {
      translateX: modelAsMercatorCoordinate.x,
      translateY: modelAsMercatorCoordinate.y,
      translateZ: modelAsMercatorCoordinate.z,
      rotateX: modelRotate[0],
      rotateY: modelRotate[1],
      rotateZ: modelRotate[2],
      /* Since our 3D model is in real world meters, a scale transform needs to be
       * applied since the CustomLayerInterface expects units in MercatorCoordinates.
       */
      scale: modelAsMercatorCoordinate.meterInMercatorCoordinateUnits(),
    }

    for (let i = 0; i < model.length; i++) {
      var customLayer = {
        id: '3d-model' + i,
        type: 'custom',
        renderingMode: '3d',
        onAdd: function (map, gl) {
          this.camera = new THREE.PerspectiveCamera()
          this.scene = new THREE.Scene()
          var _this = this
          // var geometry = new THREE.BoxGeometry( 1000, 1000, 1000 )
          // var material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } )
          // this.cube = new THREE.Mesh( geometry, material )
          // this.scene.add( this.cube )
          // 创建两个3.js灯光来照亮模型
          var light = new THREE.AmbientLight(0xffffff)
          // directionalLight.position.set(1000, 1000, 10).normalize();
          this.scene.add(light)
          // 使用three.js FBX加载程序将三维模型添加到three.js场景中
          var loader = new GLTFLoader()
          _this.animationMixer = new THREE.AnimationMixer(this.scene)
          loader.load(
            model[i],
            function (gltf) {
              gltf.scene.children[0].material.opacity = 0.5
              // const animationClip = gltf.animations.find(animationClip => animationClip.name === "贝塞尔圆.002Action.001");
              // console.log(animationClip)
              _this.action = _this.animationMixer.clipAction(gltf.animations[0])
              _this.action.setDuration(1).play()
              _this.scene.add(gltf.scene)
            }.bind(this)
          )
          this.map = map
          // use the Mapbox GL JS map canvas for three.js
          this.renderer = new THREE.WebGLRenderer({
            canvas: map.getCanvas(),
            context: gl,
            antialias: true,
          })
          this.renderer.autoClear = false
          this.raycaster = new THREE.Raycaster()
        },
        render: function (gl, matrix) {
          this.animationMixer && this.animationMixer.update(0.008)
          var rotationX = new THREE.Matrix4().makeRotationAxis(
            new THREE.Vector3(0.8, 0, 0),
            modelTransform.rotateX
          )
          var rotationY = new THREE.Matrix4().makeRotationAxis(
            new THREE.Vector3(0, 0.8, 0),
            modelTransform.rotateY
          )
          var rotationZ = new THREE.Matrix4().makeRotationAxis(
            new THREE.Vector3(0, 0, 0.8),
            modelTransform.rotateZ
          )
          var m = new THREE.Matrix4().fromArray(matrix)
          var l = new THREE.Matrix4()
            .makeTranslation(
              modelTransform.translateX,
              modelTransform.translateY,
              modelTransform.translateZ
            )
            .scale(
              new THREE.Vector3(modelTransform.scale, -modelTransform.scale, modelTransform.scale)
            )
            .multiply(rotationX)
            .multiply(rotationY)
            .multiply(rotationZ)

          this.camera.projectionMatrix.elements = matrix
          this.camera.projectionMatrix = m.clone().multiply(l)
          this.camera.matrixWorldInverse = new THREE.Matrix4()
          this.renderer.resetState()

          const freeCamera = this.map.getFreeCameraOptions()
          let cameraPosition = new THREE.Vector4(
            freeCamera.position.x,
            freeCamera.position.y,
            freeCamera.position.z,
            1
          )
          cameraPosition.applyMatrix4(l.invert())
          let direction = mouse.clone().applyMatrix4(this.camera.projectionMatrix.clone().invert())
          direction.divideScalar(direction.w)
          this.raycaster.set(cameraPosition, direction.sub(cameraPosition).normalize())
          this.renderer.render(this.scene, this.camera)
          this.map.triggerRepaint()
        },
      }
      map.addLayer(customLayer, '永川区底')
    }
  }

  //获取map对象
  getMap() {
    return map
  }

  //地图点击事件
  _clickMap(e, _this) {
    console.log('点击坐标：' + [e.lngLat.lng, e.lngLat.lat])
    let features = map.queryRenderedFeatures(e.point)
    /** 模型点击事件 **/
    var mouse = new THREE.Vector2() //创建二维平面
    e.preventDefault()
    mouse.x = (e.point.x / window.innerWidth) * 2 - 1
    mouse.y = -(e.point.y / window.innerHeight) * 2 + 1
    // 通过摄像机和鼠标位置更新射线
    window.tb.raycaster.setFromCamera(mouse, window.tb.camera)
    console.log(1)
    // 计算物体和射线的焦点
    const intersects = window.tb.raycaster.intersectObjects(window.tb.scene.children, true)
    if (intersects.length > 0) {
      Bus.emit('openBuild')
      var popup = new AnimatedPopup({
        offset: [0, -20],
        openingAnimation: {
          duration: 1000,
          easing: 'easeOutElastic',
          transform: 'scale',
        },
        closingAnimation: {
          duration: 300,
          easing: 'easeInBack',
          transform: 'opacity',
        },
      })
        .setLngLat(intersects[0].object.end)
        .setHTML('Hello World!')
        .addTo(map)
    }
    /** 模型点击事件end */
    console.log(2)
    /**点击河流水库 */
    let state = true
    for (let i = 0; i < features.length; i++) {
      if (
        features[i].layer.id === 'xzgl-河流水质' ||
        features[i].layer.id === 'sx-二级河流' ||
        features[i].layer.id === 'sx-二级河流-加粗' ||
        features[i].layer.id === 'sx-二级河流-加粗2' ||
        features[i].layer.id === 'sx-二级河流-12+' ||
        features[i].layer.id === 'sx-支流线'
      ) {
        // this.cancelSelect()
        // map.setFilter('hdhj-河道管理范围面', ['all', ['==', 'hlmc', features[i].properties.NAME]])
        // map.setFilter('hdhj-划界河流', ['all', ['==', 'NAME', features[i].properties.NAME]])
        // map.setFilter('hdhj-界桩', ['all', ['==', 'hlmc', features[i].properties.NAME]])
        // map.setLayoutProperty('hdhj-遮盖', 'visibility', 'visible')
        // features[i] && Bus.emit('mapClick', features[i])
        // state = false
        break
      } else if (features[i].layer.id.indexOf('水库') != -1 && features[i].layer.id != '水库') {
        // features[i] && Bus.emit('mapClick', features[i])
        // state = false
        break
      } else if (
        features[0].layer.type === 'symbol' &&
        features[0].layer.id.indexOf('-text') == -1
      ) {
        console.log('features[0]', features[0])
        Bus.emit('mapClick', {
          data: features[0].properties,
          modalType: features[0].properties.modalType,
        })
        state = false
        break
      }
    }
    console.log(3)
    /**点击河流end */
    /**判断点击的是否为蒙层-click**/
    if (features[0] && state && map.getZoom() <= 14) {
      // console.log(features)
      if (features[0].layer.id === 'yd-乡镇-click') {
        this.removeLyMark()
        // Bus.emit('mapClick', features[0])
        map.setPaintProperty('zj-乡镇注记', 'text-halo-width', [
          'case',
          ['boolean', ['feature-state', 'click'], false],
          3,
          ['case', ['boolean', ['feature-state', 'hover'], false], 3, 0],
        ])
        if (clickedStateId) {
          map.setFeatureState(
            { source: 'yc', id: clickedStateId, sourceLayer: '乡镇标记点' },
            { click: false }
          )
        }
        clickedStateId = features[0].id
        map.setFeatureState(
          { source: 'yc', id: clickedStateId, sourceLayer: '乡镇标记点' },
          { click: true }
        )
        // newFlowLine && (newFlowLine.remove(), newFlowLine = undefined)
        let data
        let bbox = [[], []]
        let i = 0
        // activeName = features[i].properties.NAME
        map.setFeatureState(
          { source: 'yc', id: hoveredStateId, sourceLayer: '乡镇' },
          { hover: false }
        )
        for (let m = 0; m < xzData.features.length; m++) {
          if (xzData.features[m].properties.NAME === features[i].properties.NAME) {
            zjClickFun && zjClickFun(features[i].properties.NAME)
            if (xzData.features[m].geometry.type == 'MultiPolygon') {
              data = xzData.features[m].geometry.coordinates
            } else {
              data = [xzData.features[m].geometry.coordinates]
            }
            // newFlowLine = new flowLine.flowLineLayer(
            //     "flowLineLayer",
            //     data,
            //     2,
            //     "#9ffdd8",
            //     "#ffffff",
            //     2500,
            //     0
            // );
            // newFlowLine.start()
            getFitBounds(xzData.features[m].geometry.coordinates)
            break
          }
        }
        map.removeLayer('xzgl-dem')
        // {
        //     "id": "xzgl-dem",
        //     "type": "raster",
        //     "source": "demglndj",
        //     "minzoom": 6,
        //     "layout": {"visibility": "visible"},
        //     "paint": {"raster-opacity": 1}
        //   },
        map.removeSource('demglndj')
        map.addSource('demglndj', {
          type: 'raster',
          tiles: [
            'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/hthz2/dem/dem_gl/' +
            features[i].properties.XZM +
            '/{z}/{x}/{y}.png',
          ],
          minzoom: 8,
          maxzoom: 14,
        })
        map.addLayer(
          {
            id: 'xzgl-dem',
            type: 'raster',
            source: 'demglndj',
            minzoom: 6,
            maxzoom: 14.5,
            layout: { visibility: 'visible' },
            paint: {
              'raster-opacity': {
                stops: [
                  [13, 1],
                  [14.5, 0.5],
                ],
              },
            },
          },
          'xzgl-河流水质'
        )
        map.setFilter('xzgl-河流水质', ['all', ['==', 'xzm', features[i].properties.XZM]])
        // map.setFilter('q_xz', ['all', ['==', 'NAME', features[i].properties.NAME]]);
        map.setFilter('q_xz-细线', ['all', ['==', 'NAME', features[i].properties.NAME]])
        map.setFilter('xzgl-imgzg', ['all', ['!=', 'NAME', features[i].properties.NAME]])
        map.setLayoutProperty('xzgl-imgzg', 'visibility', 'visible')
        map.setFilter('xzgl-乡镇yy1', ['all', ['==', 'NAME', features[i].properties.NAME]])
        map.setFilter('xzgl-乡镇yy2', ['all', ['==', 'NAME', features[i].properties.NAME]])
        map.setFilter('xzgl-乡镇yy3', ['all', ['==', 'NAME', features[i].properties.NAME]])
        map.setFilter('xzgl-永川乡镇界yy1', ['all', ['==', 'NAME', features[i].properties.NAME]])
        map.setFilter('xzgl-永川乡镇界yy2', ['all', ['==', 'NAME', features[i].properties.NAME]])
        map.setFilter('xzgl-永川乡镇界yy3', ['all', ['==', 'NAME', features[i].properties.NAME]])
        map.setFilter('xzgl-永川乡镇界-light', ['all', ['==', 'NAME', features[i].properties.NAME]])

        //取消流域高亮
        // map.setLayoutProperty('ly-全区流域边线1', 'visibility', 'visible')
        // map.setLayoutProperty('ly-全区流域边线2', 'visibility', 'visible')
        map.setFilter('ly-imgzg', ['all'])
        map.setLayoutProperty('ly-imgzg', 'visibility', 'none')
        map.setFilter('ly-gl-yc流域边线line', ['any', ['==', 'NAME', '']])

        //取消河道选中
        map.setFilter('hdhj-河道管理范围面yy', ['all', ['==', 'hlmc', '']])
        map.setFilter('hdhj-河道管理范围面', ['all', ['==', 'hlmc', '']])
        map.setFilter('hdhj-划界河流', ['all'])
        map.setFilter('hdhj-界桩', ['all', ['==', 'hlmc', '']])
        map.setFilter('hdhj-界桩标记', ['all', ['==', 'hlmc', '']])
        map.setFilter('hdhj-界桩名', ['all', ['==', 'hlmc', '']])

        function getFitBounds(data) {
          for (let m = 0; m < data.length; m++) {
            if (typeof data[m] === 'object') {
              getFitBounds(data[m])
            } else {
              if (bbox[0][m] != 0 && !bbox[0][m]) {
                bbox[0][m] = data[m]
              } else {
                if (bbox[0][m] > data[m]) {
                  bbox[0][m] = data[m]
                }
              }

              if (bbox[1][m] != 0 && !bbox[1][m]) {
                bbox[1][m] = data[m]
              } else {
                if (bbox[1][m] < data[m]) {
                  bbox[1][m] = data[m]
                }
              }
            }
          }
        }
        this.fitBounds(bbox, {
          padding: 100,
          pitch: 20,
          maxZoom: 12.5,
          speed: 0.2,
        })
      } else if (features[0].layer.id === '巡河轨迹') {
        Bus.emit('mapClick', {
          data: features[0].properties,
          modalType: features[0].properties.modalType,
        })
      }
    }
    /**判断点击的是否为蒙层end */
  }

  //鼠标覆盖事件
  _mousemoveMap(e) {
    let features = map.queryRenderedFeatures(e.point, { layers: ['yd-乡镇-click'] })
    map.setFilter('乡镇', ['all', ['==', 'NAME', features[0].properties.NAME]])
  }

  //删除图层
  removeLayer(id) {
    this.removeLyMark()
    let flag = false
    for (let i = customLayer.length - 1; i >= 0; i--) {
      if (customLayer[i] && customLayer[i].id === id) {
        flag = true
        customLayer[i].remove()
        map.getSource(id) && map.removeSource(id)
      }
    }
    if (!flag) {
      map.getLayer(id) && map.removeLayer(id)
      map.getSource(id) && map.removeSource(id)
    }
  }
  //删除所有图层
  removeAllLayer() {
    this.removeLyMark()
    for (let i = customLayer.length - 1; i >= 0; i--) {
      if (customLayer[i] && customLayer[i].id) {
        let sourceId = customLayer[i].id
        customLayer[i].remove()
        map.getSource(sourceId) && map.removeSource(sourceId)
      }
    }
    this.removeDiversionWaterLayer() //删除引调提水图层
    this.removeProblemPoint() //删除问题点
    this.removeHeatMap() //删除热力图
  }

  //扩散效果
  spread() {
    !spreadSetTimeout &&
      (spreadSetTimeout = setTimeout(() => {
        let x = 1000
        clearInterval(spreadSetInterval)
        spreadSetInterval = setInterval(() => {
          x += 1000
          if (x > 240000) {
            x = 1000
          }
          if (x < 150000) {
            map.setPaintProperty('dis', 'circle-opacity', [
              'case',
              ['<', ['/', ['-', 6000, ['abs', ['-', x, ['get', 'distance']]]], 6000], 0],
              0,
              ['>', ['/', ['-', 6000, ['abs', ['-', x, ['get', 'distance']]]], 6000], 1],
              0,
              ['/', ['-', 6000, ['abs', ['-', x, ['get', 'distance']]]], 6000],
            ])
          } else {
            map.setPaintProperty('dis', 'circle-opacity', 0.1)
          }
        }, 10)
      }, 4000))
  }
  //停止扩散
  stopSpread() {
    map.setPaintProperty('dis', 'circle-opacity', 0)
    clearTimeout(spreadSetTimeout)
    spreadSetTimeout = undefined
    clearInterval(spreadSetInterval)
    spreadSetInterval = undefined
  }

  //路线跟踪
  routeTracking(data, i) {
    routeTrackingData = data
    clickStart = false
    map.scrollZoom.disable()
    map.boxZoom.disable()
    map.dragRotate.disable()
    map.dragPan.disable()
    map.keyboard.disable()
    map.doubleClickZoom.disable()
    routeTrackingState = ''
    !i && (i = 0)
    flyTo(data[i])
    function flyTo(position) {
      let bearing = undefined
      if (i < data.length - 1) {
        bearing = azimuth(...data[i], ...data[i + 1])
      }
      let options = {
        center: position,
        zoom: 15,
        pitch: 60,
        speed: i == 0 ? 3 : 0.4,
        curve: 1,
        easing: (t) => {
          switch (routeTrackingState) {
            case 'suspend':
              map.stop()
              routeTrackingIndex = i
              break
            case 'stop':
              map.stop()
              clickStart = true
              map.scrollZoom.enable()
              map.boxZoom.enable()
              map.dragRotate.enable()
              map.dragPan.enable()
              map.keyboard.enable()
              map.doubleClickZoom.enable()
              break
            default:
              if (t >= 0.95 && i < data.length - 1) {
                setTimeout(() => {
                  i++
                  flyTo(data[i])
                }, 10)
              }
              if (t == 1 && i == data.length - 1) {
                clickStart = true
                map.scrollZoom.enable()
                map.boxZoom.enable()
                map.dragRotate.enable()
                map.dragPan.enable()
                map.keyboard.enable()
                map.doubleClickZoom.enable()
              }
          }
          return t //飞行时间进度
        },
      }
      bearing && (options.bearing = bearing)
      map.flyTo(options)
    }

    function azimuth(lng_a, lat_a, lng_b, lat_b) {
      var a = ((90 - lat_b) * Math.PI) / 180
      var b = ((90 - lat_a) * Math.PI) / 180
      var AOC_BOC = ((lng_b - lng_a) * Math.PI) / 180
      var cosc = Math.cos(a) * Math.cos(b) + Math.sin(a) * Math.sin(b) * Math.cos(AOC_BOC)
      var sinc = Math.sqrt(1 - cosc * cosc)
      var sinA = (Math.sin(a) * Math.sin(AOC_BOC)) / sinc
      var A = (Math.asin(sinA) * 180) / Math.PI
      var res = 0
      if (lng_b > lng_a && lat_b > lat_a) res = A
      else if (lng_b > lng_a && lat_b < lat_a) res = 180 - A
      else if (lng_b < lng_a && lat_b < lat_a) res = 180 - A
      else if (lng_b < lng_a && lat_b > lat_a) res = 360 + A
      else if (lng_b > lng_a && lat_b == lat_a) res = 90
      else if (lng_b < lng_a && lat_b == lat_a) res = 270
      else if (lng_b == lng_a && lat_b > lat_a) res = 0
      else if (lng_b == lng_a && lat_b < lat_a) res = 180
      return res
    }
  }
  //暂停
  routeTrackingSuspend() {
    routeTrackingState = 'suspend'
  }
  //停止
  routeTrackingStop() {
    routeTrackingState = 'stop'
  }
  //开始
  routeTrackingstart() {
    if (routeTrackingState == 'suspend') {
      this.routeTracking(routeTrackingData, routeTrackingIndex)
    } else {
      this.routeTracking(routeTrackingData)
    }
  }

  //绘制等值线
  // isoLine() {
  //     let waterData = require("@/assets/json/waterData.json");
  //     var data = [
  //         { "Lat": 36.18, "Lon": 103.75, "value": 0.4 },
  //         { "Lat": 36.17, "Lon": 103.29, "value": 12 },
  //         { "Lat": 37.98, "Lon": 102.75, "value": 23 },
  //         { "Lat": 36.59, "Lon": 104.91, "value": 38 },
  //         { "Lat": 33.59, "Lon": 106.11, "value": 13 },
  //         { "Lat": 36.22, "Lon": 107.78, "value": 57 },
  //         { "Lat": 31.72, "Lon": 111.78, "value": 85 },
  //         { "Lat": 34.12, "Lon": 105.78, "value": 94 }
  //     ]
  //     var features = waterData.data.map(i => {
  //         return {
  //             type: "Feature",
  //             properties: {
  //                 value: parseInt(i.BZSZLBN)
  //             },
  //             geometry: {
  //                 type: "Point",
  //                 coordinates: [parseFloat(i.JD), parseFloat(i.WD)]
  //             }
  //         }
  //     }
  //     )
  //     map.addLayer({
  //         "id": "points",
  //         "type": "circle",
  //         "source": {
  //             "type": "geojson",
  //             "data": {
  //                 "type": "FeatureCollection",
  //                 "features": features
  //             }
  //         },
  //         "paint": {
  //             "circle-radius": 10,
  //             "circle-color": "#007cbf"
  //         }
  //     });
  //     var points = turf.featureCollection(features);
  //     // var points = turf.randomPoint(30, { bbox: [105.56, 28.9, 106.2, 29.66] });
  //     // //再生成些随机数做属性
  //     // turf.featureEach(points, function (currentFeature, featureIndex) {
  //     //     currentFeature.properties = { value: (Math.random() * 100).toFixed(2) };
  //     // });
  //     var interpolate_options = {
  //         gridType: "points",
  //         property: "value",
  //         units: "degrees",
  //         weight: 10
  //     };
  //     var grid = turf.interpolate(points, 0.005, interpolate_options);
  //     // 适当降低插值结果的精度便于显示
  //     // grid.features.map((i) => (i.properties.value = i.properties.value.toFixed(2)));
  //     var isobands_options = {
  //         zProperty: "value",
  //         commonProperties: {
  //             "fill-opacity": 0.8
  //         },
  //         breaksProperties: [
  //             { fill: "#00a5d7" },
  //             { fill: "#00a5d7" },
  //             { fill: "#0bbb28" },
  //             { fill: "#e7d603" },
  //             { fill: "#d87000" },
  //             { fill: "#FF5252" }
  //         ]
  //     };
  //     var isobands = turf.isobands(
  //         grid,
  //         [0, 1, 2, 3, 4, 5, 6],
  //         isobands_options
  //     );

  //     isobands = turf.flatten(isobands);
  //     // let lineData = require("@/assets/json/yc河流.json");
  //     // console.log(lineData.features[0].geometry.coordinates[0])
  //     // var layer2 = turf.polygon(lineData.features[0].geometry.coordinates[0]);
  //     // console.log(layer2)
  //     // isobands.features.forEach(function (layer1) {
  //     //     let intersection = null;
  //     //     try {
  //     //         intersection = turf.intersect(layer1, layer2);
  //     //     } catch (e) {
  //     //         layer1 = turf.buffer(layer1, 0);
  //     //         intersection = turf.intersect(layer1, layer2);
  //     //     }
  //     //     if (intersection != null) {
  //     //         intersection.properties = layer1.properties;
  //     //         intersection.id = Math.random() * 100000;
  //     //         features.push(intersection);
  //     //     }
  //     // })
  //     // var intersection = turf.featureCollection(features);
  //     // console.log(intersection)
  //     map.addLayer({
  //         "id": "testt",
  //         "type": "fill",
  //         "source": {
  //             "type": "geojson",
  //             "data": isobands
  //         },
  //         'paint': {
  //             'fill-color': ["get", "fill"],
  //             'fill-opacity': ["get", "fill-opacity"]
  //         }
  //     });
  // }

  //地图复位
  reset() {
    map.flyTo(initialObject)
    this.cancelSelect()
    this.fitBoundsByName('永川全区域')
  }
  //取消镇街及河道选中效果
  cancelSelect() {
    if (!map) {
      return
    }
    if (clickedStateId) {
      map.setFeatureState(
        { source: 'yc', id: clickedStateId, sourceLayer: '乡镇标记点' },
        { click: false }
      )
    }
    map.setFilter('xzgl-河流水质', ['all'])
    map.setLayoutProperty('xzgl-dem', 'visibility', 'none')
    map.setFilter('q_xz-细线', ['all', ['==', 'NAME', '']])
    map.setFilter('xzgl-imgzg', ['all', ['!=', 'NAME', '']])
    map.setLayoutProperty('xzgl-imgzg', 'visibility', 'none')
    map.setFilter('xzgl-乡镇yy1', ['all', ['==', 'NAME', '']])
    map.setFilter('xzgl-乡镇yy2', ['all', ['==', 'NAME', '']])
    map.setFilter('xzgl-乡镇yy3', ['all', ['==', 'NAME', '']])
    map.setFilter('xzgl-永川乡镇界yy1', ['all', ['==', 'NAME', '']])
    map.setFilter('xzgl-永川乡镇界yy2', ['all', ['==', 'NAME', '']])
    map.setFilter('xzgl-永川乡镇界yy3', ['all', ['==', 'NAME', '']])
    map.setFilter('xzgl-永川乡镇界-light', ['all', ['==', 'NAME', '']])
    // map.setFilter('xzgl-乡镇注记-未选中', ['all', ['!=', 'NAME', '']])
    // map.setLayoutProperty('xzgl-乡镇注记-未选中', 'visibility', 'none')

    //取消河道选中
    map.setFilter('hdhj-河道管理范围面yy', ['all', ['==', 'hlmc', '']])
    map.setFilter('hdhj-河道管理范围面', ['all', ['==', 'hlmc', '']])
    map.setFilter('hdhj-划界河流', ['all'])
    map.setFilter('hdhj-界桩', ['all', ['==', 'hlmc', '']])
    map.setFilter('hdhj-界桩标记', ['all', ['==', 'hlmc', '']])
    map.setFilter('hdhj-界桩名', ['all', ['==', 'hlmc', '']])
  }

  //取消流域选中效果
  cancelSelectly() {
    // map.setLayoutProperty('ly-全区流域边线1', 'visibility', 'visible')
    // map.setLayoutProperty('ly-全区流域边线2', 'visibility', 'visible')
    map.setFilter('ly-gl-yc流域边线line', ['any', ['==', 'NAME', '']])
  }

  //地图放大
  mapEnlarge() {
    map.flyTo({
      zoom: map.getZoom() + 1,
    })
  }
  //地图缩小
  mapNarrow() {
    map.flyTo({
      zoom: map.getZoom() - 1,
    })
  }

  //定位(根据坐标)
  flyTo(options) {
    map.flyTo(options)
  }

  //根据名称定位
  fitBoundsByName(name, state) {
    if (!map) {
      return
    }
    this.cancelSelect()
    let bbox = [[], []]
    console.log('流域数据', lyData)
    for (let m = 0; m < lyData.features.length; m++) {
      if (lyData.features[m].properties.NAME == name) {
        getFitBounds(lyData.features[m].geometry.coordinates)
        break
      }
    }
    this.HighlightRiversByName()
    if (!name || name === '永川全区域') {
      selectLY = name
      map.flyTo(initialObject)
      // map.setLayoutProperty('ly-全区流域边线1', 'visibility', 'visible')
      // map.setLayoutProperty('ly-全区流域边线2', 'visibility', 'visible')
      map.setFilter('ly-gl-yc流域边线line', ['any', ['==', 'NAME', '']])

      map.setFilter('hdhj-河道管理范围面yy', ['all', ['==', 'NAME', '']])
      map.setFilter('hdhj-河道管理范围面', ['all', ['==', 'NAME', '']])
      // map.setFilter('hdhj-划界河流', ['all', ['==', 'NAME', '']])
      // map.setFilter('hdhj-界桩', ['all', ['==', 'NAME', '']])
      // map.setFilter('hdhj-界桩标记', ['all', ['==', 'NAME', '']])
      // map.setFilter('hdhj-界桩名', ['all', ['==', 'NAME', '']])

      map.setFilter('sx-支流线', ['all'])
      map.setFilter('zj-支流注记', ['all'])
      map.setFilter('sx-二级河流-加粗', ['all'])
      map.setFilter('sx-二级河流', ['all'])
      map.setFilter('sx-二级河流-12+', ['all'])

      map.setFilter('ly-imgzg', ['all'])
      map.setLayoutProperty('ly-imgzg', 'visibility', 'none')
      // map.setLayoutProperty('ly-bj', 'visibility', 'none')
      // map.setLayoutProperty('ly-yy-xax', 'visibility', 'none')
      // map.setLayoutProperty('ly-dem_ly', 'visibility', 'none')
      // map.setLayoutProperty('ly-yc流域边线', 'visibility', 'none')
      // map.setLayoutProperty('ly-二级河流', 'visibility', 'none')
      // map.setLayoutProperty('ly-遮盖', 'visibility', 'none')
      // map.setLayoutProperty('hllx', 'visibility', 'visible')
      // map.setFilter('ly-fill', ['all', ['==', 'NAME', name]])
      // map.removeLayer('ly-dem_ly')
      // // {
      // //     "id": "xzgl-dem",
      // //     "type": "raster",
      // //     "source": "demglndj",
      // //     "minzoom": 6,
      // //     "layout": {"visibility": "visible"},
      // //     "paint": {"raster-opacity": 1}
      // //   },
      // let cName
      // switch (name) {
      //   case '长江':
      //     cName = 'cj'
      //     break
      //   case '临江河':
      //     cName = 'ljh'
      //     break
      //   case '九龙河':
      //     cName = 'jlh'
      //     break
      //   case '小安溪':
      //     cName = 'xax'
      //     break
      //   case '大陆溪':
      //     cName = 'dlx'
      //     break
      //   case '龙溪河':
      //     cName = 'lxh'
      //     break
      // }
      // map.removeSource('dem_ly')
      // map.addSource('dem_ly', {
      //   type: 'raster',
      //   tiles: [
      //     'http://47.92.244.97:7001/hthz2/dem/dem_ly/'+cName+'/{z}/{x}/{y}.png'
      //   ],
      //   minzoom: 8,
      //   maxzoom: 14,
      // })
      // map.addLayer(
      //   {
      //     "id": "ly-dem_ly",
      //     "type": "raster",
      //     "source": "dem_ly",
      //     "maxzoom": 14,
      //     "layout": {"visibility": "visible"},
      //     "paint": {"raster-opacity": {"stops": [[13, 1], [14, 0]]}}
      //   },
      //   'ly-yc流域边线'
      // )
    } else {
      map.setLayoutProperty('ly-gl-yc流域边线line', 'visibility', 'visible')
      map.setLayoutProperty('ly-imgzg', 'visibility', 'visible')
      // map.setLayoutProperty('ly-bj', 'visibility', 'visible')
      // map.setLayoutProperty('ly-yy-xax', 'visibility', 'visible')
      // map.setLayoutProperty('ly-dem_ly', 'visibility', 'visible')
      // map.setLayoutProperty('ly-yc流域边线', 'visibility', 'visible')
      // map.setLayoutProperty('ly-二级河流', 'visibility', 'visible')
      // map.setLayoutProperty('ly-遮盖', 'visibility', 'visible')
      // map.setLayoutProperty('hllx', 'visibility', 'none')
      console.log('特定的', bbox)
      bbox[0][0] &&
        this.fitBounds(bbox, {
          padding: 100,
          pitch: 45,
          maxZoom: 12.5,
          speed: 0.2,
        })
      // map.setFilter('ly-fill', ['all', ['!=', 'NAME', name]])
      // map.removeLayer('ly-dem_ly')
      // {
      //     "id": "xzgl-dem",
      //     "type": "raster",
      //     "source": "demglndj",
      //     "minzoom": 6,
      //     "layout": {"visibility": "visible"},
      //     "paint": {"raster-opacity": 1}
      //   },
      let filter = ['any']
      let filter2 = ['any']
      let filter3 = ['any']
      switch (name) {
        case '长江':
          filter.push(['==', 'hlmc', '长江'])
          filter2.push(['==', 'HLMC', '长江'])
          filter3.push(['==', 'NAME', '长江'])
          map.setFilter('ly-gl-yc流域边线line', ['any', ['==', 'NAME', name]])
          break
        case '临江河':
          filter.push(['==', 'hlmc', '临江河'])
          filter.push(['==', 'hlmc', '大竹溪'])
          filter.push(['==', 'hlmc', '圣水河'])
          filter2.push(['==', 'HLMC', '临江河'])
          filter2.push(['==', 'HLMC', '大竹溪'])
          filter2.push(['==', 'HLMC', '圣水河'])
          filter3.push(['==', 'NAME', '临江河'])
          filter3.push(['==', 'NAME', '大竹溪'])
          filter3.push(['==', 'NAME', '圣水河'])
          map.setFilter('ly-gl-yc流域边线line', ['any', ['==', 'NAME', name]])
          break
        case '九龙河':
          filter.push(['==', 'hlmc', '九龙河'])
          filter.push(['==', 'hlmc', '隆济溪'])
          filter2.push(['==', 'HLMC', '九龙河'])
          filter2.push(['==', 'HLMC', '隆济溪'])
          filter3.push(['==', 'NAME', '九龙河'])
          filter3.push(['==', 'NAME', '隆济溪'])
          map.setFilter('ly-gl-yc流域边线line', ['any', ['==', 'NAME', name]])
          break
        case '小安溪':
          filter.push(['==', 'hlmc', '小安溪'])
          filter.push(['==', 'hlmc', '太平河'])
          filter.push(['==', 'hlmc', '板桥河'])
          filter2.push(['==', 'HLMC', '小安溪'])
          filter2.push(['==', 'HLMC', '太平河'])
          filter2.push(['==', 'HLMC', '板桥河'])
          filter3.push(['==', 'NAME', '太平河'])
          filter3.push(['==', 'NAME', '板桥河'])
          map.setFilter('ly-gl-yc流域边线line', ['any', ['==', 'NAME', name]])
          break
        case '大陆溪':
          filter.push(['==', 'hlmc', '大陆溪'])
          filter.push(['==', 'hlmc', '大河溪'])
          filter.push(['==', 'hlmc', '喻家河'])
          filter2.push(['==', 'HLMC', '大陆溪'])
          filter2.push(['==', 'HLMC', '大河溪'])
          filter2.push(['==', 'HLMC', '喻家河'])
          filter3.push(['==', 'NAME', '大陆溪'])
          filter3.push(['==', 'NAME', '大河溪'])
          filter3.push(['==', 'NAME', '喻家河'])
          map.setFilter('ly-gl-yc流域边线line', ['any', ['==', 'NAME', name]])
          break
        case '龙溪河':
          filter.push(['==', 'hlmc', '龙溪河'])
          filter2.push(['==', 'HLMC', '龙溪河'])
          filter3.push(['==', 'NAME', '龙溪河'])
          map.setFilter('ly-gl-yc流域边线line', ['any', ['==', 'NAME', name]])
          break
        default:
          filter.push(['==', 'hlmc', name])
          filter2.push(['==', 'HLMC', name])
          filter3.push(['==', 'NAME', name])
      }
      // map.setLayoutProperty('ly-全区流域边线1', 'visibility', 'none')
      // map.setLayoutProperty('ly-全区流域边线2', 'visibility', 'none')

      // map.setFilter('ly-遮盖', ['all', ['==', 'NAME', name]])
      if (!state) {
        selectLY = name
        map.setFilter('ly-imgzg', ['all', ['!=', 'NAME', name]])
      } else if (selectLY && selectLY != '永川全区域') {
        map.setFilter('ly-imgzg', ['all', ['!=', 'NAME', selectLY]])
      } else {
        map.setFilter('ly-imgzg', ['all'])
        map.setLayoutProperty('ly-gl-yc流域边线line', 'visibility', 'none')
        map.setLayoutProperty('ly-imgzg', 'visibility', 'none')
      }

      map.setFilter('hdhj-河道管理范围面yy', filter)
      map.setFilter('hdhj-河道管理范围面', filter)
      // map.setFilter('hdhj-划界河流', filter)
      map.setFilter('hdhj-界桩', filter)
      map.setFilter('hdhj-界桩标记', filter)
      map.setFilter('hdhj-界桩名', filter)

      map.setFilter('sx-支流线', filter2)
      map.setFilter('zj-支流注记', filter2)
      map.setFilter('sx-二级河流-加粗', filter3)
      map.setFilter('sx-二级河流', filter3)
      map.setFilter('sx-二级河流-12+', filter3)
    }
    // map.setFilter('ly-line', ['all', ['==', 'NAME', name]])

    function getFitBounds(data) {
      for (let m = 0; m < data.length; m++) {
        if (typeof data[m] === 'object') {
          getFitBounds(data[m])
        } else {
          if (bbox[0][m] != 0 && !bbox[0][m]) {
            bbox[0][m] = data[m]
          } else {
            if (bbox[0][m] > data[m]) {
              bbox[0][m] = data[m]
            }
          }

          if (bbox[1][m] != 0 && !bbox[1][m]) {
            bbox[1][m] = data[m]
          } else {
            if (bbox[1][m] < data[m]) {
              bbox[1][m] = data[m]
            }
          }
        }
      }
    }
  }

  //选择河流
  fitBoundsByHLName(name) {
    if (!name) {
      map.setFilter('sx-支流线', ['all'])
      map.setFilter('zj-支流注记', ['all'])
      map.setFilter('sx-二级河流-加粗', ['all'])
      map.setFilter('sx-二级河流', ['all'])
      map.setFilter('sx-二级河流-12+', ['all'])
    } else {
      map.setFilter('sx-支流线', ['all', 'HLMC', name])
      map.setFilter('zj-支流注记', ['all', 'HLMC', name])
      map.setFilter('sx-二级河流-加粗', ['all', 'HLMC', name])
      map.setFilter('sx-二级河流', ['all', 'HLMC', name])
      map.setFilter('sx-二级河流-12+', ['all', 'HLMC', name])
    }
  }

  //定位(将地图缩放至边界框内)
  fitBounds(bbox, options) {
    map.fitBounds(bbox, options)
  }

  //根据名称选择区县
  selectCountyByName(name) {
    this.removeLyMark()
    let bbox = [[], []]
    let XZM
    for (let m = 0; m < xzData.features.length; m++) {
      if (xzData.features[m].properties.NAME === name) {
        XZM = xzData.features[m].properties.XZM
        getFitBounds(xzData.features[m].geometry.coordinates)
        break
      }
    }
    map.removeLayer('xzgl-dem')
    // {
    //     "id": "xzgl-dem",
    //     "type": "raster",
    //     "source": "demglndj",
    //     "minzoom": 6,
    //     "layout": {"visibility": "visible"},
    //     "paint": {"raster-opacity": 1}
    //   },
    map.removeSource('demglndj')
    map.addSource('demglndj', {
      type: 'raster',
      tiles: ['http://47.92.244.97:7001/hthz2/dem/dem_gl/' + XZM + '/{z}/{x}/{y}.png'],
      minzoom: 6,
      maxzoom: 14,
      layout: { visibility: 'visible' },
      paint: {
        'raster-opacity': {
          stops: [
            [13, 1],
            [14, 0],
          ],
        },
      },
    })
    map.addLayer(
      {
        id: 'xzgl-dem',
        type: 'raster',
        source: 'demglndj',
        minzoom: 6,
        maxzoom: 14,
        layout: { visibility: 'visible' },
        paint: {
          'raster-opacity': {
            stops: [
              [13, 1],
              [14, 0],
            ],
          },
        },
      },
      'xzgl-永川乡镇界-light'
    )

    // map.setFilter('q_xz', ['all', ['==', 'NAME', features[i].properties.NAME]]);
    map.setFilter('q_xz-细线', ['all', ['==', 'NAME', name]])
    map.setFilter('xzgl-imgzg', ['all', ['!=', 'NAME', name]])
    map.setLayoutProperty('xzgl-imgzg', 'visibility', 'visible')
    map.setFilter('xzgl-乡镇yy1', ['all', ['==', 'NAME', name]])
    map.setFilter('xzgl-乡镇yy2', ['all', ['==', 'NAME', name]])
    map.setFilter('xzgl-乡镇yy3', ['all', ['==', 'NAME', name]])
    map.setFilter('xzgl-永川乡镇界yy1', ['all', ['==', 'NAME', name]])
    map.setFilter('xzgl-永川乡镇界yy2', ['all', ['==', 'NAME', name]])
    map.setFilter('xzgl-永川乡镇界yy3', ['all', ['==', 'NAME', name]])
    map.setFilter('xzgl-永川乡镇界-light', ['all', ['==', 'NAME', name]])
    // map.setFilter('xzgl-乡镇注记-未选中', ['all', ['!=', 'NAME', name]])
    // map.setLayoutProperty('xzgl-乡镇注记-未选中', 'visibility', 'visible')

    //取消流域高亮
    // map.setLayoutProperty('ly-全区流域边线1', 'visibility', 'visible')
    // map.setLayoutProperty('ly-全区流域边线2', 'visibility', 'visible')
    map.setFilter('ly-gl-yc流域边线line', ['any', ['==', 'NAME', '']])

    //取消河道选中
    map.setFilter('hdhj-河道管理范围面yy', ['all', ['==', 'hlmc', '']])
    map.setFilter('hdhj-河道管理范围面', ['all', ['==', 'hlmc', '']])
    map.setFilter('hdhj-划界河流', ['all', ['==', 'hlmc', '']])
    map.setFilter('hdhj-界桩', ['all', ['==', 'hlmc', '']])
    map.setFilter('hdhj-界桩标记', ['all', ['==', 'hlmc', '']])
    map.setFilter('hdhj-界桩名', ['all', ['==', 'hlmc', '']])

    function getFitBounds(data) {
      for (let m = 0; m < data.length; m++) {
        if (typeof data[m] === 'object') {
          getFitBounds(data[m])
        } else {
          if (bbox[0][m] != 0 && !bbox[0][m]) {
            bbox[0][m] = data[m]
          } else {
            if (bbox[0][m] > data[m]) {
              bbox[0][m] = data[m]
            }
          }

          if (bbox[1][m] != 0 && !bbox[1][m]) {
            bbox[1][m] = data[m]
          } else {
            if (bbox[1][m] < data[m]) {
              bbox[1][m] = data[m]
            }
          }
        }
      }
    }
    this.fitBounds(bbox, {
      padding: 100,
      pitch: 20,
      maxZoom: 12.5,
      speed: 0.2,
    })
  }

  //弹框
  popup(LngLat, DOMContent, className) {
    let popup = new mapBoxGl.Popup({ offset: [0, -40], className: className })
      .setLngLat(LngLat)
      .setDOMContent(DOMContent)
      .setMaxWidth('800px')
      .addTo(map)
    return popup
  }

  //给样式添加图像
  addImage(url, name) {
    map.loadImage(url, (error, image) => {
      if (error) throw error
      map.addImage(name, image)
    })
  }

  //加载视频
  loadVideo(map, _this) {
    map.removeLayer('loading')
    map.setLayoutProperty('video', 'visibility', 'visible')
    map.getSource('video').getVideo().loop = false //取消循环播放
    map.getSource('video').getVideo().currentTime = 0
    map
      .getSource('video')
      .getVideo()
      .addEventListener('timeupdate', function (e) {
        // console.log(e.target.currentTime)
        let currentTime = e.target.currentTime
        if (currentTime >= 9 && currentTime < 10) {
          map.setLayoutProperty('背景2', 'visibility', 'none')
          map.setPaintProperty('video', 'raster-opacity', 0.6)
        } else if (currentTime >= 10 && currentTime < 11) {
          map.setPaintProperty('video', 'raster-opacity', 0.3)
        }
        if (map.getSource('video').getVideo().ended) {
          // map.getSource("video").pause();
          map.getLayer('video') && map.removeLayer('video')
          //开启地图交互
          map.scrollZoom.enable()
          map.boxZoom.enable()
          map.dragRotate.enable()
          map.dragPan.enable()
          map.keyboard.enable()
          map.doubleClickZoom.enable()
          clickStart = true
          _this.flyTo(initialObject)
        }
      })
    map.getSource('video').play()
    setTimeout(() => {
      let model = new modelLayer(
        'model',
        [
          {
            obj: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/model/ycqdh00-1.glb',
            type: 'gltf',
            scale: 1,
            units: 'meters',
            rotation: { x: 90, y: 180, z: 0 },
            anchor: 'center',
          },
          {
            obj: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/model/ycqdh00-3.glb',
            type: 'gltf',
            scale: 1,
            units: 'meters',
            rotation: { x: 90, y: 180, z: 0 },
            anchor: 'center',
          },
          {
            obj: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/model/ycqdh2-2.glb',
            type: 'gltf',
            scale: 1,
            units: 'meters',
            rotation: { x: 90, y: 180, z: 0 },
            anchor: 'center',
          },
          {
            obj: 'https://ychz.cqhtwl.com.cn/map_tile/wrpfyjs/public-all/htmap/yczhhz/model/ycqdh2-4.glb',
            type: 'gltf',
            scale: 1,
            units: 'meters',
            rotation: { x: 90, y: 180, z: 0 },
            anchor: 'center',
          },
        ],
        [105.88399665665446, 29.283965721464338, 1220]
      )
    }, 3000)
  }

  //添加河流流动图层
  addPipeAnimateLayer() {
    var time = 0
    var pointCount = 0
    let myAnimateLayer = new MapboxLayer({
      id: 'hllx',
      type: TripsLayer,
      data: hllxData.features,
      getPath: (d) => {
        if (d == undefined) {
          return []
        } else {
          let coors = []

          d.geometry.coordinates.map((c) => Object.assign(coors, c))
          if (pointCount < coors.length) {
            pointCount = coors.length
          }
          // console.log(coors)
          return coors
        }
      },
      // deduct start timestamp from each data point to avoid overflow
      getTimestamps: () => {
        let arr = []
        for (let i = 0; i < pointCount; i++) {
          arr.push(i * 0.2)
        }
        return arr
      },
      getColor: [0, 125, 255],
      opacity: 1,
      widthUnits: 'pixels',
      getWidth: 4,
      widthMinPixels: 2,
      rounded: true,
      trailLength: 60,
      currentTime: 0,
    })

    map.addLayer(myAnimateLayer, 'yd-乡镇-click')
    animate()

    function animate() {
      time = (time + 1) % 500
      myAnimateLayer.setProps({
        currentTime: time,
      })
      animation.id = requestAnimationFrame(animate)
    }
  }

  //显示图层
  showLayer(id) {
    map.getLayer(id) && map.setLayoutProperty(id, 'visibility', 'visible')
  }
  //隐藏图层
  hideLayer(id) {
    map.getLayer(id) && map.setLayoutProperty(id, 'visibility', 'none')
  }

  // 获取图层
  getLayer(id) {
    return map.getLayer(id)
  }

  //注册函数
  on(type, fun) {
    switch (type) {
      case 'zjClick':
        zjClickFun = fun
        break
      case 'zoom':
        zoomFun = fun
        break
      case 'zoomend':
        zoomendFun.push(fun)
        break
      default:
    }
  }

  //根据水质等级渲染河流
  renderRiversByWaterQuality(data, type) {
    let colors = []
    let condition
    if (type == 'zd') {
      condition = [
        'case',
        [
          'boolean',
          [
            'in',
            ['get', 'dmid'],
            ['literal', ['400084', '400085', '400053', '400067', '500036', '400063', '400064']],
          ],
          false,
        ],
        ['get', 'dmid'],
        ['get', 'zdmc'],
      ]
    } else if (type === 'sg') {
      condition = ['get', 'dmid']
    }
    for (let i = 0; i < data.length; i++) {
      let color = 'rgba(75, 194, 255, 1)'
      switch (data[i].currentWaterQuality || data[i].pjjbn) {
        case 'Ⅰ':
          color = '#5bcffb'
        case 1:
          color = '#5bcffb'
          break
        case 'Ⅱ':
          color = '#2288ff'
        case 2:
          color = '#2288ff'
          break
        case 'Ⅲ':
          color = '#0efd85'
        case 3:
          color = '#0efd85'
          break
        case 'Ⅳ':
          color = '#fcd617'
        case 4:
          color = '#fcd617'
          break
        case 'Ⅴ':
          color = '#ff9700'
        case 5:
          color = '#ff9700'
          break
        case '劣Ⅴ':
          color = '#f81313'
        case 6:
          color = '#f81313'
          break
        default:
          color = '#08F3DD'
      }
      colors.push(data[i].sectionName ? data[i].sectionName : data[i].id, color)
    }
    if (colors.length > 0) {
      map.setPaintProperty('sx-二级河流-加粗', 'fill-color', [
        'match',
        condition,
        ...colors,
        '#08F3DD',
      ])
      map.setPaintProperty('sx-二级河流', 'fill-color', ['match', condition, ...colors, '#08F3DD'])
      map.setPaintProperty('sx-二级河流-12+', 'fill-color', [
        'match',
        condition,
        ...colors,
        '#08F3DD',
      ])
      map.setPaintProperty('xzgl-河流水质', 'fill-color', [
        'match',
        condition,
        ...colors,
        '#08F3DD',
      ])
    }
    HighlighttRibutaryBefore = map.getPaintProperty('sx-支流线', 'line-color')
    HighlightRiversBefore = map.getPaintProperty('xzgl-河流水质', 'fill-color')
  }
  //取消水质显示
  closeWaterQuality() {
    map.setPaintProperty('sx-二级河流-加粗', 'fill-color', '#08F3DD')
    map.setPaintProperty('sx-二级河流', 'fill-color', '#08F3DD')
    map.setPaintProperty('sx-二级河流-12+', 'fill-color', '#08F3DD')
    map.setPaintProperty('xzgl-河流水质', 'fill-color', '#08F3DD')
    HighlighttRibutaryBefore = map.getPaintProperty('sx-支流线', 'line-color')
    HighlightRiversBefore = map.getPaintProperty('xzgl-河流水质', 'fill-color')
  }

  //添加图层（图层id，坐标，显示文字，图标名称， 图标大小， 图标锚点位置）
  addPointLayer(id, coordinates, title, icon, size = 1, iconAnchor = 'bottom') {
    map.addLayer({
      id: id,
      type: 'symbol',
      source: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: coordinates,
              },
            },
          ],
        },
      },
      layout: {
        'icon-image': icon,
        'text-field': title,
        'text-size': 26,
        'icon-size': size,
        'icon-allow-overlap': true,
        'icon-ignore-placement': true,
        'text-offset': [0, -1.5],
        'text-allow-overlap': true,
        'text-anchor': 'bottom',
        'icon-anchor': iconAnchor,
        'text-ignore-placement': true,
        'text-font': ['NotoCJK'],
      },
      paint: {
        'text-color': '#ffffff',
      },
    })
  }
  addPointsLayer(id, data, icon, size = 1, iconAnchor = 'bottom') {
    let features = []
    for (let i = 0; i < data.length; i++) {
      features.push({
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: data[i].coordinates,
        },
        properties: data[i].properties,
      })
    }
    map.addLayer({
      id: id,
      type: 'symbol',
      source: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: features,
        },
      },
      layout: {
        'icon-image': icon ? icon : ['get', 'icon'],
        'text-field': ['get', 'name'],
        'text-size': 13,
        'icon-size': size,
        'icon-allow-overlap': true,
        'icon-ignore-placement': true,
        'text-offset': [0, -3],
        'text-allow-overlap': true,
        'text-anchor': 'bottom',
        'icon-anchor': iconAnchor,
        'text-ignore-placement': true,
        'text-font': ['NotoCJK'],
      },
      paint: {
        'text-color': '#ffffff',
      },
    })
  }
  //绘制轨迹
  drawTrajectory(id, coordinates, lineColor, lineWidth, data) {
    console.log('draw', id)
    //图层ID，坐标，线颜色(默认 #ffee00)，线宽(默认 8)
    return map.addLayer({
      id: id,
      type: 'line',
      source: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              geometry: {
                type: 'LineString',
                coordinates: coordinates,
              },
              properties: data,
            },
          ],
        },
      },
      layout: {
        'line-join': 'round',
        'line-cap': 'round',
      },
      paint: {
        'line-color': lineColor ? lineColor : '#ffee00',
        'line-width': lineWidth ? lineWidth : 8,
      },
    })
  }

  //自定义html点
  customHtmlPoint(element) {
    var marker = new mapBoxGl.Marker({
      element: element,
      anchor: 'bottom',
    })
      .setLngLat([105.88399665665446, 29.383965721464338])
      .addTo(map)
    console.log(marker)
  }

  //问题点
  addProblemPoint(data) {
    for (let i = 0; i < data.length; i++) {
      var element = document.createElement('div')
      element.className = 'problem-mark'
      element.style.backgroundImage = 'url(' + require('@/assets/img/map/自动告警.svg') + ')'
      var btn = document.createElement('span')
      var btn2 = document.createElement('span')
      btn.className = 'problem-btn'
      btn2.className = 'problem-btn2'
      var name = document.createElement('p')
      name.className = 'problem-name'
      var type = document.createElement('p')
      type.className = 'problem-type'
      name.innerHTML = data[i].problemName
      type.innerHTML = data[i].problemTypeStr
      element.appendChild(name)
      element.appendChild(type)
      element.appendChild(btn)
      element.appendChild(btn2)
      var mark = new mapBoxGl.Marker({
        element: element,
        anchor: 'bottom',
      })
        .setLngLat([data[i].longitude, data[i].latitude])
        .addTo(map)
      btn.addEventListener('click', function (e) {
        e.stopPropagation()
        Bus.emit('mapClick', {
          data: data[i],
          modalType: '问题详情',
        })
      })
      btn2.addEventListener('click', function (e) {
        e.stopPropagation()
        Bus.emit('mapClick', {
          data: data[i],
          modalType: '问题详情',
        })
      })
      ProblemMark.push(mark)
    }
  }
  removeProblemPoint() {
    for (let i = ProblemMark.length - 1; i >= 0; i--) {
      ProblemMark[i].remove()
    }
    ProblemMark = []
  }

  //添加流域点
  addLyMark() {
    let data = [
      {
        type: 'Feature',
        properties: { Id: 1, NAME: '小安溪' },
        geometry: { type: 'Point', coordinates: [105.82612320763114, 29.402749273018422] },
      },
      {
        type: 'Feature',
        properties: { Id: 2, NAME: '龙溪河' },
        geometry: { type: 'Point', coordinates: [105.71486498714026, 29.234426800208027] },
      },
      {
        type: 'Feature',
        properties: { Id: 3, NAME: '九龙河' },
        geometry: { type: 'Point', coordinates: [106.04882606983516, 29.419011826361775] },
      },
      {
        type: 'Feature',
        properties: { Id: 5, NAME: '临江河' },
        geometry: { type: 'Point', coordinates: [105.92446132389281, 29.274553810118217] },
      },
      {
        type: 'Feature',
        properties: { Id: 6, NAME: '大陆溪' },
        geometry: { type: 'Point', coordinates: [105.81337265443734, 29.028111218128767] },
      },
      {
        type: 'Feature',
        properties: { Id: 7, NAME: '长江' },
        geometry: { type: 'Point', coordinates: [105.86822895044229, 29.035857182941015] },
      },
    ]
    if (LyMark.length == 0) {
      for (let i = 0; i < data.length; i++) {
        var element = document.createElement('div')
        element.className = 'ly-mark'
        element.style.backgroundImage = 'url(' + require('@/assets/img/map/流域点.svg') + ')'
        var text = document.createElement('span')
        text.innerHTML = data[i].properties.NAME
        element.appendChild(text)
        var mark = new mapBoxGl.Marker({
          element: element,
          anchor: 'bottom',
          offset: [48, 0],
        })
          .setLngLat(data[i].geometry.coordinates)
          .addTo(map)
        LyMark.push(mark)
      }
    }
  }
  removeLyMark() {
    for (let i = LyMark.length - 1; i >= 0; i--) {
      LyMark[i].remove()
    }
    LyMark = []
  }

  // 热力图
  heatMap(data, level) {
    let features = []
    for (let i = 0; i < data.length; i++) {
      features.push({
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: data[i],
        },
        properties: {},
      })
    }
    let heatmapWeight = 0.08
    switch (level) {
      case 1:
        heatmapWeight = 0.8
        break
      case 2:
        heatmapWeight = 0.4
        break
      case 3:
        heatmapWeight = 0.08
        break
      default:
    }
    map.addLayer(
      {
        id: '热力图',
        type: 'heatmap',
        source: {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: features,
          },
        },
        paint: {
          // Increase the heatmap weight based on frequency and property magnitude
          //30000
          'heatmap-weight': heatmapWeight,
          // Increase the heatmap color weight weight by zoom level
          // heatmap-intensity is a multiplier on top of heatmap-weight
          'heatmap-intensity': heatmapWeight / 2,
          // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
          // Begin color ramp at 0-stop with a 0-transparancy color
          // to create a blur-like effect.
          'heatmap-color': [
            'interpolate',
            ['linear'],
            ['heatmap-density'],
            0,
            'rgba(86,65,202,0)',
            0.1,
            'rgba(86,65,202,0.8)',
            0.2,
            'rgba(33,150,243,0.9)',
            0.4,
            'rgba(33,243,72,0.9)',
            0.5,
            'rgba(255,235,59,0.9)',
            0.9,
            'rgba(255,152,0,0.9)',
            1,
            'rgba(255,87,34,0.9)',
          ],
          // Adjust the heatmap radius by zoom level
          'heatmap-radius': 60,
          // Transition from heatmap to circle layer by zoom level
          'heatmap-opacity': 0.6,
        },
      },
      'yd-乡镇-click'
    )
  }
  //删除热力图
  removeHeatMap() {
    map.getLayer('热力图') && map.removeLayer('热力图')
    map.getSource('热力图') && map.removeSource('热力图')
  }

  // 河道划界
  openRiverDemarcation(name) {
    this.cancelSelect()
    this.cancelSelectly()
    map.setLayoutProperty('hdhj-河道管理范围面yy', 'visibility', 'visible')
    map.setLayoutProperty('hdhj-河道管理范围面', 'visibility', 'visible')
    map.setLayoutProperty('hdhj-划界河流', 'visibility', 'visible')
    map.setLayoutProperty('hdhj-界桩', 'visibility', 'visible')
    map.setLayoutProperty('hdhj-界桩标记', 'visibility', 'visible')
    map.setLayoutProperty('hdhj-界桩名', 'visibility', 'visible')
    if (!name || name === '永川全区域') {
      // map.setLayoutProperty('ly-全区流域边线1', 'visibility', 'visible')
      // map.setLayoutProperty('ly-全区流域边线2', 'visibility', 'visible')
      // map.setFilter('ly-gl-yc流域边线line', ['any'])
      map.setFilter('hdhj-河道管理范围面yy', ['all'])
      map.setFilter('hdhj-河道管理范围面', ['all'])
      map.setFilter('hdhj-划界河流', ['all'])
      map.setFilter('hdhj-界桩', ['all'])
      map.setFilter('hdhj-界桩标记', ['all'])
      map.setFilter('hdhj-界桩名', ['all'])
    } else {
      let filter = ['any']
      switch (name) {
        case '长江':
          filter.push(['==', 'hlmc', '长江'])
          map.setFilter('ly-gl-yc流域边线line', ['any', ['==', 'NAME', name]])
          break
        case '临江河':
          filter.push(['==', 'hlmc', '临江河'])
          filter.push(['==', 'hlmc', '大竹溪'])
          filter.push(['==', 'hlmc', '圣水河'])
          map.setFilter('ly-gl-yc流域边线line', ['any', ['==', 'NAME', name]])
          break
        case '九龙河':
          filter.push(['==', 'hlmc', '九龙河'])
          filter.push(['==', 'hlmc', '隆济溪'])
          map.setFilter('ly-gl-yc流域边线line', ['any', ['==', 'NAME', name]])
          break
        case '小安溪':
          filter.push(['==', 'hlmc', '小安溪'])
          filter.push(['==', 'hlmc', '太平河'])
          filter.push(['==', 'hlmc', '板桥河'])
          map.setFilter('ly-gl-yc流域边线line', ['any', ['==', 'NAME', name]])
          break
        case '大陆溪':
          filter.push(['==', 'hlmc', '大陆溪'])
          filter.push(['==', 'hlmc', '大河溪'])
          filter.push(['==', 'hlmc', '喻家河'])
          map.setFilter('ly-gl-yc流域边线line', ['any', ['==', 'NAME', name]])
          break
        case '龙溪河':
          filter.push(['==', 'hlmc', '龙溪河'])
          map.setFilter('ly-gl-yc流域边线line', ['any', ['==', 'NAME', name]])
          break
        default:
          filter.push(['==', 'hlmc', name])
      }
      // map.setLayoutProperty('ly-全区流域边线1', 'visibility', 'none')
      // map.setLayoutProperty('ly-全区流域边线2', 'visibility', 'none')

      // map.setFilter('ly-遮盖', ['all', ['==', 'NAME', name]])
      map.setFilter('hdhj-河道管理范围面yy', filter)
      map.setFilter('hdhj-河道管理范围面', filter)
      // map.setFilter('hdhj-划界河流', filter)
      map.setFilter('hdhj-界桩', filter)
      map.setFilter('hdhj-界桩标记', filter)
      map.setFilter('hdhj-界桩名', filter)
    }
  }
  // 关闭河道划界
  closeRiverDemarcation() {
    this.cancelSelect()
    this.cancelSelectly()
    map.setLayoutProperty('hdhj-河道管理范围面yy', 'visibility', 'none')
    map.setLayoutProperty('hdhj-河道管理范围面', 'visibility', 'none')
    map.setLayoutProperty('hdhj-划界河流', 'visibility', 'none')
    map.setLayoutProperty('hdhj-界桩', 'visibility', 'none')
    map.setLayoutProperty('hdhj-界桩标记', 'visibility', 'none')
    map.setLayoutProperty('hdhj-界桩名', 'visibility', 'none')
  }

  //水功能分区开关
  waterFunctionZoning(state) {
    if (state) {
      map.setLayoutProperty('sgnq-长江', 'visibility', 'visible')
      map.setLayoutProperty('sgnq-临江河二级', 'visibility', 'visible')
      map.setLayoutProperty('sgnq-大陆溪二级', 'visibility', 'visible')
      map.setLayoutProperty('sgnq-九龙河', 'visibility', 'visible')
      map.setLayoutProperty('sgnq-小安溪', 'visibility', 'visible')
      map.setLayoutProperty('sgnq-龙溪河', 'visibility', 'visible')

      map.setLayoutProperty('sx-支流线', 'visibility', 'none')
      map.setLayoutProperty('sx-二级河流-加粗', 'visibility', 'none')
      map.setLayoutProperty('sx-二级河流', 'visibility', 'none')
      map.setLayoutProperty('sx-二级河流-12+', 'visibility', 'none')
      map.setLayoutProperty('sx-河流流向', 'visibility', 'none')
    } else {
      map.setLayoutProperty('sgnq-长江', 'visibility', 'none')
      map.setLayoutProperty('sgnq-临江河二级', 'visibility', 'none')
      map.setLayoutProperty('sgnq-大陆溪二级', 'visibility', 'none')
      map.setLayoutProperty('sgnq-九龙河', 'visibility', 'none')
      map.setLayoutProperty('sgnq-小安溪', 'visibility', 'none')
      map.setLayoutProperty('sgnq-龙溪河', 'visibility', 'none')

      map.setLayoutProperty('sx-支流线', 'visibility', 'visible')
      map.setLayoutProperty('sx-二级河流-加粗', 'visibility', 'visible')
      map.setLayoutProperty('sx-二级河流', 'visibility', 'visible')
      map.setLayoutProperty('sx-二级河流-12+', 'visibility', 'visible')
      map.setLayoutProperty('sx-河流流向', 'visibility', 'visible')
    }
  }

  // 根据名称高亮河流
  HighlightRiversByName(name) {
    if (!name) {
      name = ''
    }
    HighlightRivers = name
    for (let i = 0; i < hlmData.features.length; i++) {
      if (hlmData.features[i].properties.NAME == name) {
        if (name === '太平河') {
          this.fitBounds(turf.bbox(hlmData.features[i]), {
            maxZoom: 12.5,
          })
        } else {
          this.fitBounds(turf.bbox(hlmData.features[i]))
        }
      }
    }
    map.setLayoutProperty('sx-支流线', 'visibility', 'visible')
    map.setLayoutProperty('sx-二级河流-加粗', 'visibility', 'visible')
    map.setLayoutProperty('sx-二级河流', 'visibility', 'visible')
    map.setLayoutProperty('sx-二级河流-12+', 'visibility', 'visible')
    map.setLayoutProperty('xzgl-河流水质', 'visibility', 'visible')
    map.setPaintProperty('xzgl-河流水质', 'fill-color', [
      'case',
      ['boolean', ['==', ['get', 'NAME'], name], true],
      '#3a68ff ',
      HighlightRiversBefore,
    ])
    map.setPaintProperty('sx-二级河流-加粗', 'fill-color', [
      'case',
      ['boolean', ['==', ['get', 'NAME'], name], true],
      '#3a68ff ',
      HighlightRiversBefore,
    ])
    map.setPaintProperty('sx-二级河流', 'fill-color', [
      'case',
      ['boolean', ['==', ['get', 'NAME'], name], true],
      '#3a68ff ',
      HighlightRiversBefore,
    ])
    map.setPaintProperty('sx-二级河流-12+', 'fill-color', [
      'case',
      ['boolean', ['==', ['get', 'NAME'], name], true],
      '#3a68ff ',
      HighlightRiversBefore,
    ])
    if (name) {
      map.setLayoutProperty('zj-河流注记', 'visibility', 'visible')
      map.setFilter('zj-河流注记', ['all', ['==', 'NAME', name]])
    } else {
      map.setFilter('zj-河流注记', ['all'])
    }
  }

  //添加引调提水工程图层
  addDiversionWater(data) {
    DiversionWaterData = data
    var reader = new Wkt.Wkt()
    for (let i = 0; i < data.length; i++) {
      reader.read(data[i].geometry1)
      // console.log(reader.components)
      let multiLineString = []
      for (let m = 0; m < reader.components.length; m++) {
        let multiLineString2 = []
        for (let n = 0; n < reader.components[m].length; n++) {
          multiLineString2.push([reader.components[m][n].x, reader.components[m][n].y])
        }
        multiLineString.push(multiLineString2)
      }
      const pointData = {
        type: 'FeatureCollection',
        features: [
          {
            geometry: {
              type: 'Point',
              coordinates: [reader.components[0][0].x, reader.components[0][0].y],
            },
            properties: {
              ...data[i],
              name: data[i].gcmc,
              showName: true,
              // modalType: '引调提水',
              icon: `起点.png`,
            },
            type: 'Feature',
            id: 0,
          },
          {
            geometry: {
              type: 'Point',
              coordinates: [
                reader.components[reader.components.length - 1][
                  reader.components[reader.components.length - 1].length - 1
                ].x,
                reader.components[reader.components.length - 1][
                  reader.components[reader.components.length - 1].length - 1
                ].y,
              ],
            },
            properties: {
              ...data[i],
              name: data[i].gcmc,
              showName: true,
              // modalType: '引调提水',
              icon: `终点.png`,
            },
            type: 'Feature',
            id: 0,
          },
        ],
      }
      const breathe2 = new breathe.breatheLayer('引调提水点' + i, pointData, '', 1.2, false)
      breathe2.showAnimate(1000, 'Elastic.Out')
      map.addLayer({
        id: '引调提水工程-line' + i,
        type: 'line',
        source: {
          type: 'geojson',
          data: turf.multiLineString(multiLineString),
        },
        layout: {
          'line-join': 'round',
          'line-cap': 'round',
        },
        paint: {
          'line-color': '#931626',
          'line-width': 2,
        },
      })
      map.addLayer({
        id: '引调提水工程-icon' + i,
        type: 'symbol',
        source: {
          type: 'geojson',
          data: turf.multiLineString(multiLineString),
        },
        layout: {
          'symbol-placement': 'line',
          'symbol-spacing': 50, // 图标间隔，默认为250
          'icon-image': 'b2-right.png',
          'icon-size': 0.2,
        },
      })
    }
  }

  //删除引调提水图层
  removeDiversionWaterLayer() {
    if (DiversionWaterData) {
      for (let i = 0; i < DiversionWaterData.length; i++) {
        map.getLayer('引调提水工程-icon' + i) && map.removeLayer('引调提水工程-icon' + i) //删除引调提水工程图层
        map.getLayer('引调提水工程-line' + i) && map.removeLayer('引调提水工程-line' + i) //删除引调提水工程图层
        map.getSource('引调提水工程-icon' + i) && map.removeSource('引调提水工程-icon' + i) //删除引调提水工程图层
        map.getSource('引调提水工程-line' + i) && map.removeSource('引调提水工程-line' + i) //删除引调提水工程图层
      }
    }
    DiversionWaterData = []
  }

  // 添加子流域划分
  addLyLayer() {
    console.log('sub----->', subBasinData);
    const list = JSON.parse(JSON.stringify(subBasinData.features));
    list.forEach(feature => {
      const sourceId = `subBasin-${feature.id + 1}`
      const layerId = `subBasin-${feature.id + 1}`
      if (feature.geometry.type === 'Polygon') {
        feature.geometry.coordinates[0] = feature.geometry.coordinates[0].map(item => ([this.setLonlat(item)[0], this.setLonlat(item)[1]]));
      } else {
        feature.geometry.coordinates.forEach(coords => {
          coords[0] = coords[0].map(item => ([this.setLonlat(item)[0], this.setLonlat(item)[1]]));
        })
      }
      map.addSource(sourceId, { type: 'geojson', data: feature })
      map.addLayer({ // 添加图层显示多边形
        id: layerId,
        type: 'fill',
        source: sourceId,
        layout: {},
        paint: {
          // 'fill-color': '#1a7dc7', // 多边形填充颜色
          'fill-color': '#08d5ab', // 多边形填充颜色
          'fill-opacity': 0.95, // 多边形填充透明度
          // 'fill-outline-color': '#245abe'
          'fill-outline-color': '#367C65'
        }
      });
      map.on('click', layerId, (e) => {
        console.log('已点击=====>', sourceId);
        const highLight = { 'fill-color': '#245abe', 'fill-opacity': 0.9 };
        const id = this.setAfter(sourceId, '-');
        Bus.emit('mapClick', {
          data: { id, name: `子流域${id}`, modalType: '子流域' },
          modalType: '子流域',
        })
      })
    })
  }
  // 将EPSG:32648转化为EPSG:4326
  setLonlat(val) {
    const transformed = proj4("EPSG:32648", "EPSG:4326", [val[0], val[1]]);
    return [transformed[0].toFixed(8), transformed[1].toFixed(8)]
  }
  // 获取指定部分
  setAfter(str, target) {
    const index = str.indexOf(target);
    if (index !== -1) {
      return str.substring(index + target.length);
    }
  }
  // 删除子流域划分
  removeLyLayer() {
    subBasinData.features.forEach(feature => {
      map.getSource(`subBasin-${feature.id + 1}`) && map.removeLayer(`subBasin-${feature.id + 1}`);
      map.getSource(`subBasin-${feature.id + 1}`) && map.removeSource(`subBasin-${feature.id + 1}`);
    })
  }

  // 添加临江河相关图层
  addLjhLayer(val) {
    const imageUrl = require(`@/assets/img/map/layer${val}.png`);
    map.addLayer({
        'id': `ljh-layer${val}`,
        'type': 'raster',
        'source': {
            'type': 'image',
            'url': imageUrl, // 图片的URL
            'coordinates': [ // 图片的覆盖范围（西北、东北、东南、西南）
                [105.46456007791209,29.455257418803486], 
                [106.34755500104002,29.455257418803486], 
                [106.34755500104002,29.047575248797111], 
                [105.46456007791209,29.047575248797111]
            ]
        },
    });
    // map.addLayer({
    //   id: 'ljh-layer3', // 图层ID
    //   type: 'symbol', // 图层类型，这里使用symbol类型以便控制图片位置和大小
    //   source: { // 数据源可以为空，因为我们不从数据源加载数据，而是直接在图层中使用图像
    //     type: 'geojson',
    //     data: {
    //       type: 'Feature',
    //       // geometry: { // 定义图片的坐标范围和大小，这里使用一个矩形来表示图片的覆盖范围
    //       //   type: 'Polygon',
    //       //   coordinates: [ // 坐标顺序为西南-东南-东北-西北，形成一个矩形区域
    //       //     [[105.69422116, 29.074390920], [106.03530678, 29.07619930], [106.10530860, 29.501426827], [105.5963169, 29.509368545]] // 根据需要调整这些坐标值以覆盖你的图片区域
    //       //   ]
    //       // }
    //       geometry: {
    //         type: 'Point',
    //         coordinates: [105.88417693,29.24835974] // 图像位置经纬度

    //       },
    //     },
    //   },
    //   layout: { // 控制图片的布局属性，例如锚点（anchor）和图标图像（icon-image）等
    //     'icon-image': '土壤.png', // 使用之前添加的图片名称
    //     // 'icon-anchor': 'center' // 设置锚点为图像中心，这样图像会相对于其几何形状的中心点定位
    //     'icon-size': 1 // 图标大小，可以根据需要调整以适应缩放级别变化
    //   }
    // });
  }

  // 删除临江河相关图层
  removeLjhLayer() {
    for (let i = 0; i < 10; i++) {
      map.getLayer(`ljh-layer${i}`) && map.removeLayer(`ljh-layer${i}`);
      map.getSource(`ljh-layer${i}`) && map.removeSource(`ljh-layer${i}`);
    }
  }

  resize() {
    map.resize()
  }
}

const _map_service = new mapService()
export default _map_service
export let BreatheLayer = breathe.breatheLayer
export let RotateLayer = rotate.rotateLayer
export let hangLineLayer = hangLine.hangLineLayer
// export let flowLineLayer = flowLine.flowLineLayer
export let gradualChangeLineLayer = gradualChangeLine.gradualChangeLineLayer
export let gradualChangeColumnLayer = gradualChangeColumn.gradualChangeColumnLayer
export let modelLayer = models.modelLayer
export let wallLayer = wall.wallLayer
// export let spreadLayer = spread.spreadLayer
